import React from 'react';
import PropTypes from 'prop-types';
import { BASE_CONDITION, BASE_CONDITION_COMPONENT } from '../AdvancedFilter';
import * as Feather from 'react-feather';

const AdvancedSearch = (props) => {
  const {
    columns,
    conditionComponents, 
    conditions, 
    setConditionComponents,
    setConditions
  } = props;

  const addConditionComponent = (order) => {
    const newConditionComponent = Object.assign({}, BASE_CONDITION_COMPONENT);
    newConditionComponent.order = order;
    setConditionComponents(conditionComponents.concat(newConditionComponent));

    const newCondition = Object.assign({}, BASE_CONDITION);
    newCondition.order = order;
    setConditions(conditions.concat(newCondition));
  };

  const removeConditionComponent = (order) => {
    const newConditions = conditions.filter(cond => cond.order !== order).map((cond, index) => {
      cond.order = index;

      return cond;
    });

    const newComponents = conditionComponents.filter(cond => cond.order !== order).map((cond, index) => {
      cond.order = index;

      return cond;
    });

    setConditionComponents(newComponents);
    setConditions(newConditions);
  };

  const isLastCondition = (index) => {
    return index === (conditionComponents.length - 1);
  };

  const onConditionChange = (e) => {
    let newConditions = [];
    if (conditions.find(cond => cond.order === parseInt(e.target.dataset.itemOrder))) {
      newConditions = conditions.map(cond => {
        if (cond.order !== parseInt(e.target.dataset.itemOrder)) return cond;

        cond[e.target.name] = e.target.value;
        return cond;
      });
    } else {
      const newCondition = { order: parseInt(e.target.dataset.itemOrder) };
      newCondition[e.target.name] = e.target.value;
      newConditions = conditions.concat(newCondition);
    }

    setConditions(newConditions);
  };

  return (
    <div>
      {
        conditionComponents.map((condition, index) => {
          const Component = condition.component;
          const lastCondition = isLastCondition(index);
          const action = lastCondition 
            ? () => { addConditionComponent(index + 1) } 
            : () => { removeConditionComponent(index) };
          const icon = lastCondition ? Feather.Plus : Feather.Minus;

          return (<Component
            key={`AdvancedFilterItem_${index}`}
            onActionClick={action}
            icon={icon}
            onChange={onConditionChange}
            order={index}
            datasource={conditions.find(cond => cond.order === index)}
            columns={columns} />
          );
        })
      }
    </div>
  );
};

AdvancedSearch.propTypes = {
  conditionComponents: PropTypes.array.isRequired,
  conditions: PropTypes.array.isRequired,
  setConditionComponents: PropTypes.func.isRequired,
  setConditions: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }))
};

export default AdvancedSearch;